var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"header-title"},[_c('i',{class:_vm.iconClass}),_vm._v("\n  "+_vm._s(_vm.title)+"\n "),_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }